var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"management-page-outer-container"},[_c('router-view'),_vm._v(" "),(_vm.$route.name === 'about-licenses')?_c('div',{staticClass:"data-table management-main-list-data-table"},[_c('licenses-list',[_c('v-layout',{staticStyle:{"height":"90px"}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8e210c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Licenses/Licenses.vue
// module id = null
// module chunks = 